<template>
    <div>
        <el-dialog
        :title="titles[types]"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
            <div>
                <customer-level :types="types"  v-if="types==1 || types==2" ref="customerLevel"></customer-level>
                <customer-label :types="types" v-if="types==3 || types==4 || types==5 || types==6" ref="customerLabel"></customer-label>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="cong">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
        title="提醒"
        :visible.sync="dialogVisible2"
        width="50%"
        :before-close="handleClose2">
            <div class="dlog">
                本次将给选择的{{tags.length}}位客户打上标签：
                <span >{{tags.join(",")}}</span>
                等{{tags.length}}个标签，请确认是否操作
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose2">取 消</el-button>
                <el-button type="primary" @click="config">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import customerLevel  from './custmoer/customerLevel'
import customerLabel  from './custmoer/customerLabel.vue'
export default {
    props:{
        
    },
    components:{
        customerLevel,
        customerLabel
    },
    data() {
        return {
            dialogVisible2:false,
            dialogVisible:false,
            types:0,
            titles:["","修改客户等级","修改客户积分","批量打客户标签","选择标签","选择标签","选择标签"],//5为标签组 选择标签，4为标签筛选，6渠道选择标签 只能选择运营标签
            tags:["“成交拉”","“核心”"]
        }
    },
    methods: {
        show(item){
            this.dialogVisible=true;
            this.types=item;
        },
        hidelod(){
            this.dialogVisible=false;
            this.types=0;
        },
        cong(){
            if(this.types==1 ||this.types==2){//等级 或积分
                let a=this.$refs.customerLevel.set();
                this.$emit("doSelect",a);
                this.dialogVisible=false;
            }else if(this.types==3 || this.types==4){//打标签
                let tags=this.$refs.customerLabel.set();
                if(this.types==3){
                    this.dialogVisible2=true;
                }else{
                    this.$emit("doSelect",tags);
                }
                this.dialogVisible=false;
            }
            this.types=0;
            
        },
        config(){
            this.$emit("doSelect",this.tags);
            this.dialogVisible2=false;
        },
        handleClose(e){
            this.dialogVisible=false;
            this.types=0;
            // this.types=0;
        },
        handleClose2(){
            this.dialogVisible2=false;
            this.dialogVisible=true;
        }
    },
}
</script>
<style lang="less" scoped>
.dlog{
    padding:30px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    span{
        color:#327EFF;
    }
}
    .dialog-footer{
        display: block;
      
        .el-button{
            border-radius: 30px;
        }
    }
    /deep/ .el-dialog__footer{
          border-top:1px solid #ededed;
    }
</style>